import { Capacitor } from '@capacitor/core';

export function isCapacitorNative(): boolean {
  return Capacitor.isNativePlatform();
}

export function getPlatform(): 'ios' | 'android' | 'web' {
  if (!isCapacitorNative()) return 'web';

  return Capacitor.getPlatform() as 'ios' | 'android';
}

export function getStoreUrl(iosUrl: string, androidUrl: string): string {
  const platform = getPlatform();

  const urlsMapper = {
    ios: iosUrl,
    android: androidUrl,
    web: iosUrl // default to ios for web
  };

  return urlsMapper[platform];
}
